export enum Month {
    January = 'january',
    February = 'february',
    March = 'march',
    April = 'april',
    May = 'may',
    June = 'june',
    July = 'july',
    August = 'august',
    September = 'september',
    October = 'october',
    November = 'november',
    December = 'december',
}

// const translationObject: { [Key in ImportSupplierStatus]: string } = {
//     [ImportSupplierStatus.NoInterval]: 'app.bonusSettlement.status.draft',
//     [ImportSupplierStatus.OnSchedule]: 'app.bonusSettlement.status.sent',
//     [ImportSupplierStatus.Overdue]: 'app.bonusSettlement.status.readyToComplete',
// };

// export const getImportSupplierStatusTranslationId = (status?: ImportSupplierStatus): string => {
//     return status ? translationObject[status] : 'app.bonusSettlement.status.draft';
// };
